import { create } from 'zustand';
const useDocumentVirusScanStore = create()(set => ({
    documentIds: [],
    addDocumentId: id => set(state => ({ documentIds: [...state.documentIds, id] })),
    removeDocumentIds: ids => set(state => ({
        documentIds: state.documentIds.filter(i => !ids.includes(i)),
    })),
}));
export default useDocumentVirusScanStore;
